export const domainKey = 'valuebet'
// export const domainName = `www.${domainKey}.games`
// export const domainName = `www.${domainKey}.com`
export const domainName = `www.${domainKey}.mx`
// export const domainName = 'dev.leo-pp.com'
// export const domainName = 'dev.morena888.com'
// export const domainName = 'dev-brazilv5.tt-22.com'
// export const domainName = 'dev-mexicov5.kf5588bet.com'
// export const domainName = 'dev-russ.moose888.com'
// export const host = `https://${domainName}/api` // 正式
export const host = window.location.origin + '/api' // 正式上线
// export const host = 'http://dev.rei-bet.com/api' // 测试
// export const host = "http://8.218.60.59:9202" // 测试
export const inviteCodeKey = domainKey.replace(/-/g, '') + 'Ivid'
export const domain = `https://${domainName}`
export const webSocketUrl = `wss://${domainName}/api/onlineSend`
export const pn = 'm031'

// 打包时的默认主题色，第一个主题为当前金色
export const defaultThemeSkin = 'green'
// 显示侧边栏主题调试按
export const showThemeSkinSelect = false

export const themeSkinOptions = [
    { label: 'Gold', value: 'gold' },
    { label: 'Charcoal Coral', value: 'charcoal' },
    { label: 'Blue', value: 'blue' },
    { label: 'Green', value: 'green' },
    { label: 'Ice Blue', value: 'iceblue' },
    { label: 'Blue White', value: 'porcelain' },
    { label: 'Purple', value: 'purple' },
    { label: 'Dark Gray', value: 'darkgray' }
]
